import { Authority, SearchResponse } from '@skinsoft/types'
import { Observable } from 'rxjs';

import { AuthorityOfflineDataFetcher, CACHE_KEYS } from '@skinsoft/offline'
import { EntityDataStore } from '@skinsoft/entity-data-store'

export class AuthorityDataStore extends EntityDataStore<Authority> {
    public static getInstance() {
        if (!AuthorityDataStore.instance) {
            AuthorityDataStore.instance = new AuthorityDataStore();
        }

        return AuthorityDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$AuthorityDataStore = AuthorityDataStore.getInstance();
        Vue.prototype.$collaboratorDataStore = AuthorityDataStore.getInstance();
    }

    private static instance: AuthorityDataStore = null as any;

    constructor() {
        super('authorities', ['authority']);
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new AuthorityOfflineDataFetcher(CACHE_KEYS.Authority)
    }

    public fetchByUser(userId: string): Observable<SearchResponse<Authority>> {
        const advancedSearch = [
            {
                type: "requestSearch",
                leftCriteria: {
                    type: "criteria",
                    operator: "equals",
                    entityField: "60642db6d5e3fa3fa4101294",
                    value: {
                        type: "ref",
                        refId: userId,
                    },
                },
            },
        ]
        return AuthorityDataStore.getInstance().searchAll(null, null, undefined, undefined, undefined, advancedSearch)
    }
}


